import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'alarmLevelPipe'})
export class AlarmLevelPipe implements PipeTransform {
  transform(level: number): string {
    switch(level) {
      case 1: {
        return 'Information';
      }
      case 2: {
        return 'Warning';
      }
      case 3: {
        return 'Minor';
      }
      case 4: {
        return 'Major';
      }
      case 5: {
        return 'Critical';
      }
      default: {
        return 'Unknown';
      }
    }
  }
}